export default {
  submitBtn: false,
  emptyBtn: false,
  group: [
    {
      label: '租户信息',
      prop: 'group1',
      column: [
        {
          label: '租户名称',
          prop: 'name',
          disabled: true,
        },
        {
          label: '联系电话',
          prop: 'mobile',
          disabled: true,
        },
        {
          label: '性别',
          prop: 'sex',
          disabled: true,
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=sex',
          props: { label: 'dictValue', value: 'dictKey' },
        },
        {
          label: '身份证',
          prop: 'idCard',
          disabled: true,
        },
        {
          label: '工作单位',
          width: 150,
          prop: 'companyName',
          disabled: true,
          type: 'select',
          dicUrl: 'api/v4ward/departmentCompany/getDepartmentCompanyList',
          props: { label: 'companyName', value: 'id' },
        },
      ],
    },
    {
      label: '房间费项金额',
      prop: 'group3',
      column: [
        {
          label: '水费',
          type: 'number',
          precision: '2',
          prop: 'waterAmount',
          disabled: true,
        },
        {
          label: '电费',
          type: 'number',
          precision: '2',
          prop: 'electricityAmount',
          disabled: true,
        },
        {
          label: '公摊电费',
          type: 'number',
          precision: '2',
          prop: 'meanElectricityAmount',
          disabled: true,
        },
        {
          label: '公摊水费',
          type: 'number',
          precision: '2',
          prop: 'meanWaterAmount',
          disabled: true,
        },
        {
          label: '卫生费',
          type: 'number',
          precision: '2',
          prop: 'meanHealthAmount',
          disabled: true,
        },
        {
          label: '房租费',
          type: 'number',
          precision: '2',
          prop: 'rentAmount',
          disabled: true,
        },
        {
          label: '物业费',
          type: 'number',
          precision: '2',
          prop: 'propertyFeeAmount',
          disabled: true,
        },
      ],
    },
    {
      label: '租赁信息',
      prop: 'group2',
      column: [
        {
          label: '租户类型',
          prop: 'departmentRentType',
          disabled: true,
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=department_rent_type',
          props: { label: 'dictValue', value: 'dictKey' },
        },
        {
          label: '减免金额',
          type: 'number',
          precision: '2',
          prop: 'derateMoney',
          disabled: true,
        },
        {
          label: '押金金额',
          type: 'number',
          precision: '2',
          prop: 'deposit',
          disabled: true,
        },
        {
          label: '押金编号',
          prop: 'depositNo',
          disabled: true,
        },
        {
          label: '电费起码',
          type: 'number',
          precision: '2',
          prop: 'electricityBeginNum',
          disabled: true,
        },
        {
          label: '水费起码',
          type: 'number',
          precision: '2',
          prop: 'waterBeginNumber',
          disabled: true,
        },
        {
          label: '占床位数',
          type: 'number',
          prop: 'bedUsingNum',
          disabled: true,
        },
        {
          label: '入住房间',
          prop: 'propertyName',
          disabled: true,
        },
        {
          label: '室友',
          prop: 'roommateName',
          disabled: true,
        },
        {
          label: '租用时间',
          prop: 'startDate',
          disabled: true,
          type: 'datetime',
          dataType: 'Sting',
          format: 'yyyy-MM-dd HH:mm:ss',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
        },
        {
          label: '划扣账户',
          prop: 'bankCardNo',
          disabled: true,
        },
        {
          label: '划扣银行',
          prop: 'bank',
          disabled: true,
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=bill_cutBank',
          props: { label: 'dictValue', value: 'dictKey' },
        },
      ],
    },
  ],
};
